export default [
  // {
  //   header: 'ანალიტიკა',
  // },
  // {
  //   title: 'დეშბორდი',
  //   route: 'dashboard',
  //   icon: 'GridIcon',
  // },
  // {
  //   title: 'სტატისტიკა 1',
  //   route: 'statistics-1',
  //   icon: 'BarChartIcon',
  // },
  // {
  //   title: 'სტატისტიკა 2',
  //   route: 'statistics-2',
  //   icon: 'PieChartIcon',
  // },
]
